export interface Model193 {
  modelo: string;
  ejercicio: number;
  sujetoNIF: string;
  sujetoRazonSocial: string;
  contactoTelefono: string;
  contactoNombre: string;
  numeroIdentificativo: string;
  complementaria: boolean;
  sustitutiva: boolean;
  justificante: string;
  naturalezaDeclarante: boolean;
  numeroPerceptores: number;
  totalBase: number;
  totalRetenciones: number;
  retencionesIngresadas: number;
  gastos: number;
  avisos: string[];
}

export interface Model193Validation {
  key: string | null;
  type: string;
  message: string;
}

export interface Model193Recipient {
  clave: string | null;
  uid: string | null;
  origen: string;
  sobrescribeClave: string | null;
  nifPerceptor: string;
  nifRepresentante: string;
  nombre: string;
  mediador: boolean;
  provinciaPerceptor: string;
  claveCodigo: string;
  codigoEmisor: string;
  clavePercepcion: string;
  naturaleza: string;
  pago: string;
  tipoCodigo: string;
  codigoCuentaValores: string;
  pendiente: boolean;
  ejercicioDevengo: number;
  tipoPercepcion: string;
  importePercepciones: number;
  importeReducciones: number;
  base: number;
  porcentaje: number;
  retencion: number;
  penalizaciones: number;
  isin: string;
  fechaInicioPrestamo: string;
  fechaVencimientoPrestamo: string;
  compensaciones: number;
  garantias: number;
  haciendaEstatal: number;
  navarra: number;
  alava: number;
  gipuzkoa: number;
  bizkaia: number;
  ceutaMelillaPalma: string;
  nifPagadorAnterior: string;
  fechaDevengo: string;
  claveMercado: string;
}

export interface Model193RecipientList {
  items: Model193Recipient[];
  total: number;
  page: number;
  pageSize: number;
  totalBase: number;
  totalRetenciones: number;
}

export interface Model193ListQuery {
  year: number;
  page: number;
  pageSize: number;
  search: string;
  sortBy: string;
  sortDirection: string;
}

export interface Model193FieldOriginQuery {
  campo: string;
  taxYear: number;
  valorEnElFormulario: number | null;
}

export const ORIGEN_CONTABILIDAD = 'CONTABILIDAD';
export const ORIGEN_MANUAL = 'MANUAL';

export function nuevoModelo193(): Model193 {
  return {
    modelo: '193',
    ejercicio: new Date().getFullYear() - 1,
    sujetoNIF: '',
    sujetoRazonSocial: '',
    contactoTelefono: '',
    contactoNombre: '',
    numeroIdentificativo: '',
    complementaria: false,
    sustitutiva: false,
    justificante: '',
    naturalezaDeclarante: false,
    numeroPerceptores: 0,
    totalBase: 0,
    totalRetenciones: 0,
    retencionesIngresadas: 0,
    gastos: 0,
    avisos: []
  };
}

export function normalizarModelo193(origen: Partial<Model193>): Model193 {
  const modelo: Model193 = { ...nuevoModelo193(), ...(origen || {}) } as Model193;

  modelo.modelo = '193';
  modelo.sujetoNIF = modelo.sujetoNIF || '';
  modelo.sujetoRazonSocial = modelo.sujetoRazonSocial || '';
  modelo.contactoTelefono = modelo.contactoTelefono || '';
  modelo.contactoNombre = modelo.contactoNombre || '';
  modelo.numeroIdentificativo = modelo.numeroIdentificativo || '';
  modelo.justificante = modelo.justificante || '';
  modelo.complementaria = !!modelo.complementaria;
  modelo.sustitutiva = !!modelo.sustitutiva;
  modelo.naturalezaDeclarante = !!modelo.naturalezaDeclarante;
  modelo.numeroPerceptores = Number(modelo.numeroPerceptores) || 0;
  modelo.totalBase = Number(modelo.totalBase) || 0;
  modelo.totalRetenciones = Number(modelo.totalRetenciones) || 0;
  modelo.retencionesIngresadas = Number(modelo.retencionesIngresadas) || 0;
  modelo.gastos = Number(modelo.gastos) || 0;
  modelo.avisos = Array.isArray(modelo.avisos) ? modelo.avisos : [];

  return modelo;
}

export function nuevoPerceptor193(): Model193Recipient {
  return {
    clave: null,
    uid: null,
    origen: ORIGEN_MANUAL,
    sobrescribeClave: null,
    nifPerceptor: '',
    nifRepresentante: '',
    nombre: '',
    mediador: false,
    provinciaPerceptor: '',
    claveCodigo: '',
    codigoEmisor: '',
    clavePercepcion: '',
    naturaleza: '',
    pago: '',
    tipoCodigo: '',
    codigoCuentaValores: '',
    pendiente: false,
    ejercicioDevengo: 0,
    tipoPercepcion: '1',
    importePercepciones: 0,
    importeReducciones: 0,
    base: 0,
    porcentaje: 0,
    retencion: 0,
    penalizaciones: 0,
    isin: '',
    fechaInicioPrestamo: '',
    fechaVencimientoPrestamo: '',
    compensaciones: 0,
    garantias: 0,
    haciendaEstatal: 0,
    navarra: 0,
    alava: 0,
    gipuzkoa: 0,
    bizkaia: 0,
    ceutaMelillaPalma: '0',
    nifPagadorAnterior: '',
    fechaDevengo: '',
    claveMercado: ''
  };
}

export function normalizarPerceptor193(origen: Partial<Model193Recipient>): Model193Recipient {
  const base: any = nuevoPerceptor193();
  const perceptor: any = { ...base, ...(origen || {}) };

  Object.keys(base).forEach(clave => {
    const defecto = base[clave];

    if (typeof defecto === 'string' && perceptor[clave] == null) perceptor[clave] = '';
    if (typeof defecto === 'number') perceptor[clave] = Number(perceptor[clave]) || 0;
    if (typeof defecto === 'boolean') perceptor[clave] = !!perceptor[clave];
  });

  return perceptor as Model193Recipient;
}
